/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import luxuryBlueBackground from '../../../../../../../../assets/Resources/res_default_1.webp';
import brightBubblesBackground from '../../../../../../../../assets/Resources/res_default_2.webp';
import pinkAbstractBackground from '../../../../../../../../assets/Resources/res_default_3.webp';
import image1710Background from '../../../../../../../../assets/Resources/res_default_4.webp';
import softPinkBubblesBackground from '../../../../../../../../assets/Resources/res_default_5.webp';
import grayBackground from '../../../../../../../../assets/Resources/res_default_6.webp';
import vividBlurredBackground from '../../../../../../../../assets/Resources/res_default_7.webp';
import colorfulNoiseBackground from '../../../../../../../../assets/Resources/res_default_8.webp';
import { ContentSortField, ContentSortInput, SortDirection, TimePeriod } from '../../../../../../../actions/resource_graphql_actions/content_graphql_types';

const useResourceHelper = () =>
{
	const [ searchParams ] = useSearchParams();
	const location = useLocation();

	const isAdminView = useMemo(() =>
	{
		return location?.pathname?.toLowerCase()?.includes('businesssettings') ?? false;
	}, [ location?.pathname ]);

	const isFavoritesList = useMemo(() =>
	{
		return location.pathname.toLowerCase().includes('resource/favorites');
	}, [ location.pathname ]);

	const isNetworkResource = useMemo(() =>
	{
		return location.pathname.toLowerCase().includes('resource/network');
	}, [ location.pathname ]);

	const getContentStatus = () =>
	{
		if (!isAdminView) return 'PUBLISHED';
		const apiStatus =
		{
			drafts      : 'DRAFT',
			published   : 'PUBLISHED',
			unpublished : 'UNPUBLISHED',
			scheduled   : 'SCHEDULED'
			// uncategorized : 'UNCATEGORIZED'
		};

		if (searchParams.get('status') === 'uncategorized')
		{
			return apiStatus[searchParams.get('statusFilter') || ''];
		}

		return apiStatus[searchParams.get('status') || searchParams.get('statusFilter') || ''];
	};

	const getSortDirection = (): ContentSortInput | undefined =>
	{
		const sortDirection = searchParams.get('sortDirection') || '';
		const sortField = searchParams.get('sortField') || '';

		if ([ 'ASC', 'DESC' ].includes(sortDirection) && [ 'CREATED_AT', 'NAME' ].includes(sortField))
		{
			return {
				field     : sortField as ContentSortField,
				direction : sortDirection as SortDirection
			};
		}
		else
		{
			return undefined;
		}
	};

	const getRandomBackgroundImage = useMemo(() =>
	{
		if (location.pathname === '/resource/network/companies')
		{
			return '/images/logos/no_logo.png';
		}
		const backgroundImages = [
			vividBlurredBackground,
			colorfulNoiseBackground,
			grayBackground,
			brightBubblesBackground,
			luxuryBlueBackground,
			pinkAbstractBackground,
			image1710Background,
			softPinkBubblesBackground
		];
		const randomIndex = Math.floor(Math.random() * backgroundImages.length);

		return backgroundImages[randomIndex];
	}, [ location.pathname ]);

	// const getEnabledContentTypes = (): ApiContentType[] =>
	// {
	// 	const allContentTypes: { key: ApiContentType; enabled: boolean }[] =
	// 	[
	// 		{ key: 'ARTICLE', enabled: isArticlesEnabled },
	// 		{ key: 'IMAGE', enabled: isImagesEnabled },
	// 		{ key: 'VIDEO', enabled: isVideosEnabled },
	// 		{ key: 'PODCAST', enabled: isPodcastsEnabled },
	// 		{ key: 'DOCUMENT', enabled: isDocumentsEnabled }
	// 	];

	// 	return allContentTypes
	// 		.filter((item) => item.enabled)
	// 		.map((item) => item.key);
	// };

	const getDateFilterValue = (timeRange?: TimePeriod | number) =>
	{
		const dateFilter = timeRange || (searchParams.get('dateFilter') as TimePeriod);

		if (!dateFilter) return undefined;

		const now = new Date();
		const endDate = now.getTime(); // Current time in milliseconds

		switch (dateFilter)
		{
			case TimePeriod.TODAY:
			case 2:
				const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());

				return {
					startDate : todayStart.getTime(),
					endDate
				};

			case TimePeriod.LAST_WEEK:
			case 3:
				const lastWeekStart = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

				return {
					startDate : lastWeekStart.getTime(),
					endDate
				};

			case TimePeriod.LAST_MONTH:
			case 4:
				const lastMonthStart = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

				return {
					startDate : lastMonthStart.getTime(),
					endDate
				};

			case TimePeriod.LAST_90_DAYS:
			case 5:
				const lastQuarterStart = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);

				return {
					startDate : lastQuarterStart.getTime(),
					endDate
				};

			case TimePeriod.LAST_YEAR:
			case 6:
				const lastYearStart = new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000);

				return {
					startDate : lastYearStart.getTime(),
					endDate
				};

			default:
				// If it's a number, use the original conversion
				return undefined;
		}
	};

	return {
		getContentStatus,
		getSortDirection,
		isAdminView,
		isFavoritesList,
		isNetworkResource,
		searchParams,
		getRandomBackgroundImage,
		getDateFilterValue
		// getEnabledContentTypes

	};
};

export default useResourceHelper;